module.exports = __webpack_public_path__ + "img/SKMJ_place1.c73b90ba.png";